<template>
	<div>
		<ChangeController
			:visible="dataChanged"
			@close="show = false"
			@revert="revert"
			@save="save"
		/>

		<v-card class="mb-10" rounded>
			<v-card-text>
					<h2 class="mb-4">Text</h2>
					<TextEditor
						v-model="data.text"
						@show-change="dataChanged = true"
					/>
			</v-card-text>
		</v-card>

		<v-card class="opaquerBg" rounded>
			<v-card-text>
				<Collection
					:collection="data.contacts"
					@change="dataChanged = true"
					dialogWidth="600"
					:form="$options.ContactForm"
					title="Contact Information"
					breakpoints="xs12 sm6 md6 lg3 xl2"
				>
					<ContactItem slot-scope="item" v-bind="item" />
				</Collection>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import TextEditor from '@/components/admin/TextEditor'
import DataMixin from '@/mixins/DataMixin'

import Collection from '@/components/admin/ItemCollection'
import ContactItem from '@/components/n-collections/n-items/ContactItem'

import ContactForm from '@/components/dialogs/forms/ContactForm'


export default {
	name: 'AdminContact',
	mixins: [DataMixin],
	ContactForm,
	components: {
		TextEditor,
		Collection,
		ContactItem,
	},
}
</script>

<style lang="scss" scoped>
</style>